import type { PriceVO } from '../price';

export enum PromoCodeDisplayMessageType {
  GENERIC_NON_DISCOUNT = 'GENERIC_NON_DISCOUNT',
  GENERIC_DISCOUNT = 'GENERIC_DISCOUNT',
}

export type PromotionCodeData = {
  planId: number | null;
  baasServiceId: string | null;
  promotionCode: string;
  promotionDescription: string;
  active: boolean;
  applied: boolean;
  reasonResource: string;
  reasonMessage: string;
  proratedPromotionCredit: PriceVO;
  promotionCredit: PriceVO;
};

export class PromoCodeVO {
  constructor(private data: PromotionCodeData) {}

  public getCode(): string {
    return this.data.promotionCode;
  }

  public getName(): string {
    return this.data.promotionCode;
  }

  public getPromotionCredit(): PriceVO {
    return this.data.promotionCredit;
  }

  public getProratedPromotionCredit(): PriceVO {
    return this.data.proratedPromotionCredit;
  }

  public getBaasServiceId(): string | null {
    return this.data.baasServiceId;
  }

  public getPlanId(): number | null {
    return this.data.planId;
  }

  public getPromotionDescription(): string {
    return this.data.promotionDescription;
  }

  public isActive(): boolean {
    return this.data.active;
  }

  public isApplied(): boolean {
    return this.data.applied;
  }

  public getReasonResource(): string {
    return this.data.reasonResource;
  }

  public getReasonMessage(): string {
    return this.data.reasonMessage;
  }

  public isLocked(): boolean {
    return this.data.active;
  }

  public isProrated(): boolean {
    return this.data.proratedPromotionCredit.priceAmount > 0;
  }

  public isNonDiscount(): boolean {
    return this.data.promotionCredit.priceAmount === 0 && this.data.proratedPromotionCredit.priceAmount === 0;
  }

  public getDisplayMessageType(): PromoCodeDisplayMessageType {
    if (this.isNonDiscount()) {
      return PromoCodeDisplayMessageType.GENERIC_NON_DISCOUNT;
    }

    return PromoCodeDisplayMessageType.GENERIC_DISCOUNT;
  }

  public getDiscountAmount(): PriceVO | null {
    if (this.isNonDiscount()) {
      return null;
    }

    return this.isProrated() ? this.data.proratedPromotionCredit : this.data.promotionCredit;
  }
}
